<template lang="html">
  <div class="CRUDGenerico__Wrapper" v-if="canAccessPage">
    <v-row>
      <v-col cols="12" sm="3" v-if="!somenteLeitura">
        <role-form
          ref="roleForm"
          @FORMULARIO_CADASTRO_ROLE_SALVAR="onSalvarRole"
        />
      </v-col>
      <v-col cols="12" :sm="somenteLeitura ? 12 : 9">
        <role-lista
          ref="roleLista"
          class="CRUDGenerico__ContentTable"
          :title="$tc('label.role', 2)"
          @PESQUISA_ROLE_EDITAR="onEditarRole"/>
      </v-col>
    </v-row>
  </div>
</template>

<script type="text/javascript">
import { generateComputed } from '@/common/functions/roles-computed-generator';
import RoleForm from './RoleForm';
import RoleLista from './RoleLista';

export default {
  name: 'RoleCadastro',
  data() {
    return {
    };
  },
  components: {
    RoleForm,
    RoleLista,
  },
  computed: {
    ...generateComputed('DIVISAO', [
      'canAccessCRUD',
      'canAccessPage',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast(this.$t('message.acesso_negado'));
      }
    },
    onEditarRole(role) {
      this.$refs.roleForm.editar(role);
    },
    onSalvarRole() {
      this.$refs.roleLista.filtrar();
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};
</script>
<style scoped>
.CRUDGenerico__ContentTable  {
  width: 100%;
}
</style>
